import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AbcIconCacheService {
  public cache = signal<Map<string, string>>(new Map());
}
